/**------------------------------------------------------
 * Enum Definitions
 */
export enum EnumNgTagInputEditModes {
	TagInput		= 'tag_input',
	Readonly		= 'readonly',
	SelectionInput 	= 'selection_input',
	ReorderTags 	= 'reorder_tags'
}

export enum EnumNgTagInputAction {
	Add				= 'add',
	Edit			= 'edit',
	Remove			= 'remove',
	Drag			= 'drag',
	Keystroke		= 'keystroke',
	MaxLimit		= 'max_limit',
	MouseClick  	= 'mouse_click'
}

export enum EnumNgSuggestionType {
	Inline 			= 'inline',
	Filled			= 'filled'
}

export enum EnumNgSuggestionMode {
	Auto   			= 'auto',
	Manual 			= 'manual'
}

export enum EnumNgAlignment {
	Left			= 'left',
	Middle			= 'middle',
	Right			= 'right'
}

export enum EnumNgCasingType {
	IgnoreCasing 	= 'ignore_casing',
	LowerCase 		= 'lower_case',
	UpperCase 		= 'upper_case'
}

export type TypeNgTagInputAppearance = 'accent' | 'form-control';


/**------------------------------------------------------
 * Interface Definitions
 */
export interface INgTagInputEvent {
	action 		 : EnumNgTagInputAction;
	value  		 : string;
	tags   		 : string[];
	event 		?: PointerEvent | MouseEvent;
}

export interface INgTagInputConfig {
	editMode	 : EnumNgTagInputEditModes;   // tag_input
	duplication	 : boolean; 				// false
	casingType	 : EnumNgCasingType;			// will force a specific casing
	hintText	 : string; 					// "+ Add"
	minTags		 : number; 					// 0
	maxTags		 : number; 					// Number.MAX_SAFE_INTEGER
	maxTagLength : number;					// max char length of single tag
	height		 : number;
	inputClass	 : string;
	alignment	 : EnumNgAlignment;
	suggestion	 : {
		type	 : EnumNgSuggestionType;
		mode	 : EnumNgSuggestionMode;
	};
}


/**------------------------------------------------------
 * Type Definitions
 */
export type TypeNgValidationAndEscapeFn = (tag: string) => string;
